import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { RolePermissionEffects } from './role-permission.effects'
import * as fromRolePermission from './role-permission.reducer'
import { RolePermissionSerializer } from './role-permission.serializer'
import { RolePermissionService } from './role-permission.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromRolePermission.FEATURE_NAME,
      fromRolePermission.rolePermissionReducer
    ),
    EffectsModule.forFeature([RolePermissionEffects])
  ],
  providers: [
    RolePermissionService,
    {
      provide: RolePermissionSerializer,
      useClass: RolePermissionSerializer
    }
  ]
})
export class RolePermissionModule {}
